<template>
  <div>
    <v-dialog
      ref="dateDialog"
      v-model="dateModal"
      :return-value.sync="internalDate"
      persistent
      lazy
      full-width
      width="290px"
    >
      <v-text-field
        slot="activator"
        v-model="dateFormatted"
        :label="name"
        prepend-icon="event"
        readonly
      ></v-text-field>
      <v-date-picker
        v-model="internalDate"
        scrollable
        first-day-of-week="1"
      >
        <v-spacer></v-spacer>
        <v-btn
          flat
          color="primary"
          @click="dateModal = false"
        >{{ $vuetify.t('$vuetify.lobis.cancel') }}</v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.dateDialog.save(internalDate)"
        >{{ $vuetify.t('$vuetify.lobis.ok') }}</v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: new Date().toISOString().slice(0, 10)
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dateModal: false,
      idate: null
    }
  },
  created () {
    if (!this.date) {
      this.internalDate = new Date().toISOString().slice(0, 10)
    }
  },
  computed: {
    dateFormatted () {
      return this.formatDate(this.internalDate)
    },
    internalDate: {
      get () {
        return this.date
      },
      set (value) {
        this.$emit('update:date', value)
      }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Formcomponents/Datepicker.vue